module.exports = __webpack_public_path__ + "static/img/anos_30.154678a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/linha-tempo/anos_30.png
// module id = 72ug
// module chunks = 0